import { reatomAsync, withDataAtom } from "@reatom/async"
import { onConnect } from "@reatom/hooks"

import { fetchCompetences } from "modules/PsyCatalog/common/Filters/api"

export const competencesFetcher = reatomAsync(fetchCompetences, "fetchCompetences").pipe(
    withDataAtom({
        groups: [],
        list: [],
    })
)
onConnect(competencesFetcher.dataAtom, competencesFetcher)
